<template>
  <div class="invest-list">
    <div v-for="video in videoList" :key="video.id" class="invest-card">
      <!-- 封面 -->
      <div class="invest-cover">
        <img :src="video.img" :alt="video.title" class="cover-img" />
        <div class="cover-overlay">
          <div class="play-btn">
            <PlayCircleOutlined :style="{ fontSize: '56px', color: '#fff' }" />
          </div>
        </div>
        <!-- 状态角标 -->
        <div class="cover-badge" v-if="video.status === 3">
          <span class="badge badge-wait">{{ $t('_bq._jjks') }}</span>
        </div>
        <div class="cover-badge" v-else-if="video.status === 1">
          <span class="badge badge-active">{{ $t('_bq._jxz') }}</span>
        </div>
      </div>

      <!-- 信息 -->
      <div class="invest-info">
        <div class="info-top">
          <div class="title-row">
            <h3 class="invest-title">{{ video.title }}</h3>
            <span class="invest-code">#{{ video.code }}</span>
          </div>

          <!-- 倒计时 -->
          <div class="countdown-wrap" v-if="video.begin_seconds > 0 || video.end_seconds > 0">
            <div class="countdown-header">
              <!-- <span class="countdown-icon">⏳</span> -->
              <span class="countdown-label">
                {{ video.begin_seconds > 0 ? $t('_bq._jks') : $t('_bq._jjs') }}
              </span>
            </div>
            <div class="countdown-timer">
              <div class="time-block">
                <span class="time-num">{{ video.begin_seconds > 0 ? video.begin.days : video.end.days }}</span>
                <span class="time-text">{{ $t('_bq._t') }}</span>
              </div>
              <span class="time-colon">:</span>
              <div class="time-block">
                <span class="time-num">{{ video.begin_seconds > 0 ? video.begin.hours : video.end.hours }}</span>
                <span class="time-text">{{ $t('_bq._h') }}</span>
              </div>
              <span class="time-colon">:</span>
              <div class="time-block">
                <span class="time-num">{{ video.begin_seconds > 0 ? video.begin.minutes : video.end.minutes }}</span>
                <span class="time-text">{{ $t('_bq._m') }}</span>
              </div>
              <span class="time-colon">:</span>
              <div class="time-block">
                <span class="time-num">{{ video.begin_seconds > 0 ? video.begin.seconds : video.end.seconds }}</span>
                <span class="time-text">{{ $t('_bq._s') }}</span>
              </div>
            </div>
            <div class="countdown-footer">{{ video.begin_seconds > 0 ? $t('_bq._kssj') : $t('_bq._jssj') }}：{{ formatDate(video.begin_seconds > 0 ? video.begin_time : video.end_time) }}</div>
          </div>

          <!-- 信息网格 -->
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">{{ $t('_bqq._tzdj') }}</span>
              <span class="info-value price">${{ video.price }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">{{ $t('_bqq._hdts') }}</span>
              <span class="info-value">{{ video.days }} {{ $t('_bq._t') }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">{{ $t('_bqq._vip') }}</span>
              <span class="info-value">Lv.{{ video.level }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">{{ $t('_bqq._rjcy') }}</span>
              <span class="info-value">{{ video.pre_num }} {{ $t('_bqq._cs') }}</span>
            </div>
          </div>

          <!-- 进度 -->
          <div class="progress-wrap">
            <div class="progress-header">
              <span class="progress-label">{{ $t('_bqq._ysjd') }}</span>
              <span class="progress-percent">{{ ((video.sold / video.num || 0) * 100).toFixed(2) }}%</span>
            </div>
            <div class="progress-bar">
              <div class="progress-fill" :style="{ width: (video.sold / video.num || 0) * 100 + '%' }"></div>
            </div>
          </div>
        </div>

        <!-- 底部操作 -->
        <div class="info-bottom">
          <button class="btn-buy" @click="onBuy(video)" :disabled="video.status !== 1">
            <i class="fas fa-shopping-cart"></i>
            {{ video.status === 1 ? $t('_bqq._ljqg') : $t('_bqq._zbkqg') }}
          </button>
        </div>
      </div>
    </div>

    <!-- 加载更多 -->
    <div class="load-more">
      <button class="load-btn" @click="loadMore" v-if="hasMore" :disabled="loading">
        <i class="fas fa-spinner fa-spin" v-if="loading"></i>
        {{ loading ? $t('_bqq._jzz') : $t('_bqq._jzgd') }}
      </button>
      <div class="no-more" v-else>— {{ $t('_bqq._wz') }} —</div>
    </div>

    <!-- 购买弹窗 -->
    <InvestBuy ref="buy" @success="onSuccess" />
  </div>
</template>

<script>
import { PlayCircleOutlined } from '@ant-design/icons-vue'
import InvestBuy from '@/components/adv/InvestBuy.vue'

export default {
  name: 'VideoInvestList',
  components: {
    PlayCircleOutlined,
    InvestBuy
  },
  data() {
    return {
      loading: false,
      hasMore: true,
      page: 1,
      size: 4,
      videoList: [],
      countdownTimers: {}
    }
  },
  mounted() {
    this.getList()
  },
  beforeUnmount() {
    Object.values(this.countdownTimers).forEach((timer) => clearInterval(timer))
  },
  methods: {
    onBuy(item) {
      if (item.status !== 1) {
        this.$message.warning('当前活动不可购买')
        return
      }
      this.$api.videoInvest
        .snapUp({ id: item.id })
        .then((res) => {
          if (res.code === 1) {
            this.$message.warning(res.msg)
            return
          }
          if (res.data.status === 1) {
            this.$message.warning(this.$t('_ggtf._qgrtd'))
            return
          }
          if (res.data.status === 2) {
            this.$refs.buy.open(item, res.data.code)
          }
        })
        .catch(() => {})
    },

    onSuccess() {
      this.getList(1)
    },

    getList(page = 0) {
      if (page > 0) {
        this.videoList = []
        this.page = page
        this.hasMore = true
      }
      if (this.loading) return

      this.loading = true

      this.$api.videoInvest
        .getVideoInvestList({
          page: this.page,
          size: this.size
        })
        .then((res) => {
          this.loading = false
          this.page++

          if (res.data.length === 0) {
            this.hasMore = false
            return
          }

          res.data.forEach((item) => {
            if (item.begin_seconds > 0) {
              const time = this.$common.formatTimeRemaining(item.begin_seconds)
              item.begin = time
                ? {
                    days: String(time.days || 0).padStart(2, '0'),
                    hours: String(time.hours || 0).padStart(2, '0'),
                    minutes: String(time.minutes || 0).padStart(2, '0'),
                    seconds: String(time.seconds || 0).padStart(2, '0')
                  }
                : { days: '00', hours: '00', minutes: '00', seconds: '00' }
            }
            if (item.end_seconds > 0) {
              const time = this.$common.formatTimeRemaining(item.end_seconds)
              item.end = time
                ? {
                    days: String(time.days || 0).padStart(2, '0'),
                    hours: String(time.hours || 0).padStart(2, '0'),
                    minutes: String(time.minutes || 0).padStart(2, '0'),
                    seconds: String(time.seconds || 0).padStart(2, '0')
                  }
                : { days: '00', hours: '00', minutes: '00', seconds: '00' }
            }
            this.videoList.push(item)
          })

          this.videoList.forEach((item) => {
            this.startCountdown(item)
          })

          this.hasMore = res.data.length >= this.size
        })
        .catch(() => {
          this.loading = false
        })
    },

    startCountdown(item) {
      const key = item.id
      if (this.countdownTimers[key]) {
        clearInterval(this.countdownTimers[key])
        delete this.countdownTimers[key]
      }

      const hasBegin = item.begin_seconds > 0
      const hasEnd = item.end_seconds > 0
      if (!hasBegin && !hasEnd) return

      this.countdownTimers[key] = setInterval(() => {
        const target = this.videoList.find((v) => v.id === item.id)
        if (!target) {
          clearInterval(this.countdownTimers[key])
          return
        }

        const isBegin = target.begin_seconds > 0
        const timeObj = isBegin ? target.begin : target.end
        if (!timeObj) return

        let days = parseInt(timeObj.days) || 0
        let hours = parseInt(timeObj.hours) || 0
        let minutes = parseInt(timeObj.minutes) || 0
        let seconds = parseInt(timeObj.seconds) || 0

        seconds--
        if (seconds < 0) {
          seconds = 59
          minutes--
          if (minutes < 0) {
            minutes = 59
            hours--
            if (hours < 0) {
              hours = 23
              days--
            }
          }
        }

        if (days < 0) {
          clearInterval(this.countdownTimers[key])
          return
        }

        timeObj.days = String(days).padStart(2, '0')
        timeObj.hours = String(hours).padStart(2, '0')
        timeObj.minutes = String(minutes).padStart(2, '0')
        timeObj.seconds = String(seconds).padStart(2, '0')
      }, 1000)
    },

    formatDate(date) {
      if (!date) return '--'
      const d = new Date(date)
      return d.toLocaleDateString('zh-CN') + ' ' + d.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' })
    },

    loadMore() {
      this.getList()
    }
  }
}
</script>

<style scoped>
/* ============================================================
   版权投资列表 - 深灰主题（字号优化版）
   ============================================================ */

.invest-list {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0;
  color: #e8edf2;
}

/* ============================================================
   卡片
   ============================================================ */
.invest-card {
  display: flex;
  background: #1a1f26;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 24px;
  border: 1px solid #2a3038;
  transition: all 0.35s ease;
}

.invest-card:hover {
  border-color: #ffb300;
  /* transform: translateY(-4px); */
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);
}

/* ============================================================
   封面
   ============================================================ */
.invest-cover {
  position: relative;
  flex: 0 0 280px;
  /* height: 210px; */
  overflow: hidden;
  background: #0a0d0f;
}

.cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.invest-card:hover .cover-img {
  transform: scale(1.06);
}

.cover-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.35s ease;
}

.invest-card:hover .cover-overlay {
  opacity: 1;
}

.play-btn {
  width: 64px;
  height: 64px;
  background: rgba(255, 179, 0, 0.2);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.35s ease;
}

.invest-card:hover .play-btn {
  transform: scale(1.15);
}

/* ============================================================
   封面角标
   ============================================================ */
.cover-badge {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 2;
}

.badge {
  display: inline-block;
  padding: 6px 18px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.badge-wait {
  background: rgba(255, 179, 0, 0.9);
  color: #0b0d0f;
}

.badge-active {
  background: rgba(38, 166, 154, 0.9);
  color: #fff;
}

/* ============================================================
   信息区
   ============================================================ */
.invest-info {
  flex: 1;
  padding: 18px 24px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
}

.info-top {
  flex: 1;
}

.title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  flex-wrap: wrap;
  gap: 8px;
}

.invest-title {
  font-size: 20px;
  font-weight: 700;
  color: #e8edf2;
  margin: 0;
  line-height: 1.3;
}

.invest-code {
  font-size: 15px;
  color: #5a6672;
  background: #0a0d0f;
  padding: 4px 14px;
  border-radius: 10px;
  font-family: monospace;
}

/* ============================================================
   倒计时
   ============================================================ */
.countdown-wrap {
  background: #0a0d0f;
  border-radius: 12px;
  padding: 14px 18px;
  margin-bottom: 16px;
  border: 1px solid #2a3038;
}

.countdown-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  justify-content: center;
}

.countdown-icon {
  font-size: 16px;
}

.countdown-label {
  font-size: 15px;
  color: #6a7a8a;
  font-weight: 500;
}

.countdown-timer {
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: center;
}

.time-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #14181c;
  border-radius: 8px;
  padding: 6px 12px;
  min-width: 52px;
}

.time-num {
  font-size: 26px;
  font-weight: 800;
  color: #ffb300;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}

.time-text {
  font-size: 14px;
  color: #5a6672;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.time-colon {
  font-size: 24px;
  font-weight: 700;
  color: #2a3038;
  padding: 0 4px;
}

.countdown-footer {
  font-size: 16px;
  color: #dddddd;
  margin-top: 6px;
  text-align: center;
}

/* ============================================================
   信息网格
   ============================================================ */
.info-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 14px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.info-label {
  font-size: 12px;
  color: #5a6672;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 16px;
  color: #e8edf2;
  font-weight: 600;
}

.info-value.price {
  color: #ffb300;
  font-size: 18px;
}

/* ============================================================
   进度条
   ============================================================ */
.progress-wrap {
  margin-bottom: 6px;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.progress-label {
  font-size: 14px;
  color: #6a7a8a;
}

.progress-percent {
  font-size: 14px;
  color: #ffb300;
  font-weight: 600;
}

.progress-bar {
  width: 100%;
  height: 6px;
  background: #2a3038;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #ffb300, #f57c00);
  border-radius: 4px;
  transition: width 0.8s ease;
}

/* ============================================================
   底部操作
   ============================================================ */
.info-bottom {
  padding-top: 14px;
  border-top: 1px solid #2a3038;
  display: flex;
  justify-content: flex-end;
}

.btn-buy {
  padding: 10px 36px;
  border: none;
  border-radius: 30px;
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 16px rgba(255, 179, 0, 0.15);
}

.btn-buy:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(255, 179, 0, 0.3);
}

.btn-buy:active:not(:disabled) {
  transform: scale(0.97);
}

.btn-buy:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* ============================================================
   加载更多
   ============================================================ */
.load-more {
  text-align: center;
  padding: 30px 0 10px;
}

.load-btn {
  padding: 12px 44px;
  border: 1px solid #2a3038;
  border-radius: 30px;
  background: transparent;
  color: #8a949f;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.load-btn:hover:not(:disabled) {
  border-color: #ffb300;
  color: #e8edf2;
}

.load-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.no-more {
  color: #3a4652;
  font-size: 15px;
  letter-spacing: 1px;
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 820px) {
  .invest-card {
    flex-direction: column;
  }

  .invest-cover {
    flex: 0 0 auto;
    height: 180px;
    width: 100%;
  }

  .invest-info {
    padding: 16px 18px 14px;
  }

  .invest-title {
    font-size: 18px;
  }

  .info-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .time-num {
    font-size: 22px;
  }

  .time-block {
    min-width: 42px;
    padding: 4px 10px;
  }

  .btn-buy {
    flex: 1;
    justify-content: center;
    padding: 10px 20px;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .invest-cover {
    height: 140px;
  }

  .invest-info {
    padding: 12px 14px 12px;
  }

  .invest-title {
    font-size: 16px;
  }

  .title-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .invest-code {
    font-size: 15px;
  }

  .info-grid {
    grid-template-columns: 1fr 1fr;
    gap: 6px;
  }

  .info-value {
    font-size: 14px;
  }

  .info-value.price {
    font-size: 15px;
  }

  .countdown-wrap {
    padding: 10px 14px;
  }

  .countdown-label {
    font-size: 13px;
  }

  .time-num {
    font-size: 18px;
  }

  .time-block {
    min-width: 34px;
    padding: 3px 8px;
  }

  .time-colon {
    font-size: 18px;
  }

  .time-text {
    font-size: 10px;
  }

  .countdown-footer {
    font-size: 13px;
  }

  .btn-buy {
    font-size: 14px;
    padding: 8px 18px;
  }

  .load-btn {
    padding: 10px 28px;
    font-size: 14px;
  }
}
</style>
